import { render, staticRenderFns } from "./FindingApprovalComponent.vue?vue&type=template&id=0f9fa9e5&"
import script from "./FindingApprovalComponent.vue?vue&type=script&lang=js&"
export * from "./FindingApprovalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports